import React from "react";
import { ReportField } from "./ReportField";
import { Box } from "@mui/material";

interface LocalAreaInsightsContainerProps {
  userId: string;
  propertyId: string;
}

export const LocalAreaInsightsContainer: React.FC<
  LocalAreaInsightsContainerProps
> = ({ userId, propertyId }) => {
  return (
    <Box sx={{ px: 6 }}>
      {/* Note: Neighbourhood highlights will be handled internally by the ReportField component */}
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Neighbourhood Highlights"
        fieldKey="localAreaInsights.neighbourhoodHighlights"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Recent Comparable Sales"
        fieldKey="localAreaInsights.recentComparableSales"
      />
    </Box>
  );
};
